export const room_status = {
	"0": "Trống",
	"1": "Đã cọc, chưa vào ở",
	"2": "Đã nhận phòng",
	"3": "Báo trả phòng",
	"4": "Báo trả phòng và đã có cọc mới",
};
export const list_building = [
	{ text: "Bảo Ngọc", value: "BN" },
	{ text: "Gia Bảo", value: "GB" },
	{ text: "Thanh Tâm", value: "TT" },
	{ text: "Xuân Anh", value: "XA" },
	{ text: "Mai Anh", value: "MA" },
	{ text: "B Minh Tâm", value: "MT" },
];
export const list_disbursement_type = [
	{ text: "Chi trả cọc", value: "return_deposit" },
	{ text: "Chi hoa hồng", value: "commission" },
	{ text: "Chi lương", value: "employee_wage" },
	{ text: "Chi khác", value: "other" },
];
